import { makeStyles } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";
import flag from "~/static/images/flag-logo.png";

const flagIcon = {
  width: 16,
  height: 16,
  borderRadius: "50%",
  display: "inline-block",
  position: "relative",
  marginRight: 5,
  top: 1,
  background: `url(${flag}) no-repeat transparent`,
  backgroundSize: "16px auto",
  "&[class=\"ar\"]": {
    backgroundPosition: "0 3px"
  },
  "&[class=\"zh\"]": {
    backgroundPosition: "0 -12px"
  },
  "&[class=\"en\"]": {
    backgroundPosition: "0 -28px"
  },
  "&[class=\"de\"]": {
    backgroundPosition: "0 -44px"
  },
  "&[class=\"id\"]": {
    backgroundPosition: "0 -62px"
  },
  "&[class=\"pt\"]": {
    backgroundPosition: "0 -79px"
  },
};

const headerStyles = makeStyles(theme => ({
  containerRootStyle: {
    [theme.breakpoints.up("md")]: {
      paddingTop: "12px",
      paddingBottom: "12px",
      paddingRight: "36px"
    },
    [theme.breakpoints.down("sm")]: {
      "& nav": {
        padding: "8px 0 !important",
        "& a": {
          marginTop: "0"
        }
      }
    }
  },
  icnStyle: {
    height: "24px",
    width: "24px",
    color: theme.palette.primary.mfs
  },
  "@keyframes slideRight": {
    from: {
      opacity: 0,
      transform: "translateX(-100px)"
    },
    to: {
      opacity: 1,
      transform: "none"
    }
  },
  fixed: {},
  header: {
    position: "fixed",
    color: theme.palette.common.white,
    zIndex: 99999999,
    background: "none",
    boxShadow: "none",
    transition: "all 0.5s ease-out",
    [theme.breakpoints.down("sm")]: {
      background: "#fff"
    },
    "& > *": {
      [theme.breakpoints.down("md")]: {
        padding: 0
      }
    },
    "&$fixed": {
      background: theme.palette.background.paper,
      [theme.breakpoints.down("sm")]: {
        background: "#fff"
      },
      boxShadow: theme.shadows[5],
      "& $socialBtn": {
        border: `1px solid ${theme.palette.primary.mfs}`,
        "& i": {
          color: theme.palette.primary.mfs
        },
        "&:hover": {
          backgroundColor: theme.palette.primary.mfs,
          "& i": {
            color: theme.palette.primary.white
          }
        }
      }
    },
    "&$openDrawer": {
      zIndex: 1600,
      boxShadow: "none",
    },
  },
  headerContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& nav": {
      alignItems: "center",
      padding: theme.spacing(2),
      paddingLeft: "0px",
      paddingRight: "0px",
      [theme.breakpoints.down("md")]: {
        padding: theme.spacing(2, 0),
        width: "100%"
      },
      display: "flex"
    }
  },
  logo: {
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      alignSelf: "center",
      alignItems: "center",
      textAlign: "center",
      width: "100%",
    },
    "& a": {
      textDecoration: "none",
      display: "block",
      fontSize: 16,
      color: theme.palette.type === "dark" ? theme.palette.text.primary : theme.palette.primary.main,
      alignItems: "center",
      transition: "color 0.5s ease-out",
      fontWeight: theme.typography.fontWeightMedium,
      textAlign: "center"
    },
    "& img": {
      display: "block",
      margin: "0 auto",
      transition: "all 0.3s ease-out",
      height: "100%",
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: "185px",
        height: "auto",
      },
      [theme.breakpoints.down("sm")]: {
        width: "185px",
        height: "auto",
      }
    }
  },
  active: {},
  button: {
    width: theme.spacing(20)
  },
  navMenu: {
    [theme.breakpoints.up("lg")]: {
      "& > *": {
        margin: theme.spacing(0, 1),
      },
    },
    "& a": {
      marginTop: theme.spacing(0.5),
      fontSize: 16,
      fontWeight: theme.typography.fontWeightMedium,
      boxShadow: "none",
      position: "relative",
      margin: theme.spacing(0, 1),
      [theme.breakpoints.up("md")]: {
        margin: "0px 2px",
      }
    },
    "& ul": {
      listStyle: "none",
      marginLeft: 0,
      paddingLeft: 0,
      "& li": {
        margin: theme.spacing(0, 1),
        listStyle: "none",
        position: "relative",
        display: "inline-block",
        "& a:not(:last-child)": {
          background: "none !important",
        },
        "& a": {
          textTransform: "capitalize",
          minWidth: 0,
          padding: "6px",
          "&:after": {
            content: "\"\"",
            height: 6,
            width: 6,
            transform: "scale(0)",
            position: "absolute",
            borderRadius: "50%",
            margin: "0 auto",
            bottom: -5,
            background: theme.palette.primary.main,
            transition: "all 0.2s cubic-bezier(0.42, 0.16, 0.21, 0.93)"
          },
          "&:hover": {
            transition: "all 0.3s ease-out",
            color: fade(theme.palette.text.primary, 0.5),
            "&:after": {
              transform: "scale(1)",
            }
          }
        },
        "&[class=\"active\"]": {
          "& a": {
            color: theme.palette.type === "dark" ? theme.palette.primary.light : theme.palette.primary.main,
            "&:after": {
              transform: "scale(1)",
            },
          }
        }
      }
    },
    "&$invert": {
      "& $socialBtn": {
        background: fade(theme.palette.primary.main, 0.24),
        "& i": {
          color: theme.palette.primary.main
        }
      },
    }
  },
  margin: {},
  langMenu: {
    textTransform: "capitalize",
    "& i": {
      ...flagIcon
    }
  },
  socialBtn: {
    background: fade(theme.palette.common.white, 0.24),
    width: 35,
    height: 35,
    padding: theme.spacing(0.5),
    [theme.breakpoints.down("md")]: {
      margin: "0 6px"
    },
    "& i": {
      color: theme.palette.common.white,
      fontSize: 22,
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.mfs
    }
  },
  icon: {},
  invert: {},
  setting: {
    margin: theme.spacing(0, 1),
    "& $icon": {
      transition: "all 0.3s ease",
      color: theme.palette.common.white,
      "&$invert": {
        "& svg": {
          fill: theme.palette.text.secondary
        }
      }
    },
    "& svg": {
      fill: theme.palette.common.white,
      width: 30,
      height: 30,
      [theme.breakpoints.down("xs")]: {
        fill: theme.palette.text.secondary
      },
    },
    "& $active": {
      transform: "rotate(30deg)"
    }
  },
  modeMenu: {
    textTransform: "capitalize"
  },
  bar: {
    backgroundColor: theme.palette.text.secondary,
    "&:after, &:before": {
      backgroundColor: theme.palette.text.secondary
    }
  },
  menu: {},
  openDrawer: {},
  paperNav: {
    width: "100%",
    background: theme.palette.background.paper,
    [theme.breakpoints.up(680)]: {
      width: 300,
    },
  },
  mobileMenu: {
    margin: theme.spacing(0, 1),
    zIndex: 500,
    width: "100%",
    display: "flex",
    justifyContent: "space-between"
  },
  mobileNav: {
    background: theme.palette.background.paper,
    height: "100%",
    "& $menu": {
      padding: theme.spacing(0, 0),
      overflow: "auto",
      top: 90,
      width: "100%",
      position: "absolute",
      height: "calc(100% - 90px)",
      "& a": {
        animationName: "$slideRight",
        animationTimingFunction: "ease"
      },
    }
  },
  menuList: {
    textTransform: "capitalize",
    "& span": {
      fontSize: 24
    }
  },
  isTrans: {
    color: theme.palette.primary.white
  },
  menuText: {},
  menuInner: {},
  menuItemText: {},
  menuHasMargin: {},
  separator: {
    height: "12px",
    width: "100%",
    backgroundColor: theme.palette.primary.gray
  },
  menuSection: {
    padding: theme.spacing(0, 5),
    "& $menuText": {
      fontSize: "22px !important",
      color: `${theme.palette.primary.mfs} !important`,
      fontWeight: "600 !important",
    },
    "& $menuHasMargin": {
      marginTop: "28px"
    },
    "& $menuInner": {
      marginBottom: "32px",
      "& a": {
        textDecoration: "none",
        "& $menuItemText": {
          fontSize: "20px",
          color: theme.palette.primary.btnText,
          fontWeight: 600,
          lineHeight: "24px",
          marginBottom: "22px",
        }
      }
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "24px",
    }
  },
  topMenuSection: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "12px"
    }
  },
  langBtn: {
    backgroundColor: theme.palette.primary.white,
  },
  selectedStyle: {
    width: 0,
    height: 0,
    fontSize: "16px",
    fontWeight: "600",
    color: "#212121",
    "& > .MuiSelect-select": {
      "&:focus": {
        backgroundColor: "transparent"
      }
    },
    "& > .MuiSelect-icon": {
      width: 0,
      height: 0
    }
  },
  linkStyle: {
    textDecoration: "none",
    fontSize: "16px",
    fontWeight: "600",
    color: "#212121",
  },
  formRoot: {
    width: 0,
    height: 0,
    position: "absolute",
    left: "20px",
    top: "23px"
  },
  logoAdjust: {
    [theme.breakpoints.up("md")]: {
      left: "6px",
      position: "relative"
    }
  },
  registButton: {
    backgroundColor: "#35508C",
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
    "& > .MuiButton-label": {
      color: "#fff"
    },
    "&:hover": {
      filter: "none", // Menghilangkan filter blur saat dihover
      backgroundColor: "rgba(53, 81, 140,0.9)",
    },
  },
  icnUser: {
    color: "#fff",
    fontSize: 24,
    marginRight: 6
  },
  ctnAccount: {
    position: "relative",
  },
  accountWrapper: {
    "& > .MuiButton-label": {
      fontSize: 16,
      textTransform: "none",
      fontWeight: 600,
      color: "#000"
    },
    [theme.breakpoints.down("md")]: {
      zIndex: 1000,
      marginRight: "0px !important"
    }
  },
  avatarStyle: {
    width: 36,
    height: 36,
    borderRadius: 20,
    overflow: "hidden",
    marginRight: 12,
    [theme.breakpoints.down("md")]: {
      marginRight: 0
    }
  },
  rowLink: {
    display: "flex",
    alignItems: "center"
  },
  ctnMobile: {
    position: "relative"
  },
  ctnCountryPayment: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "& > img": {
      width: 24,
      height: 24,
      marginRight: 8
    },
    "& > span": {
      fontSize: 16,
      fontWeight: 800,
      color: "#3E3E3E"
    }
  },
  arrowIcon: {
    color: "#3E3E3E",
    fontSize: 27,
    marginLeft: 2
  },
  ctnMobileCountry: {
    marginTop: 40,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "& > img": {
      width: 24,
      height: 24,
      marginRight: 8
    },
  },
  txtMenuCountry: {
    fontSize: "20px",
    color: theme.palette.primary.btnText,
    fontWeight: 600,
    lineHeight: "24px",
  }
}));

export default headerStyles;
